import React, { useEffect, useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col,
    Spinner
} from "reactstrap";

import BasicModal from '../../../../components/Modals/BasicModal'
import SelectInstitution from './SelectInstitution';
import { getInstitutions } from "../../../../network/ApiAxios";
import { titleCase } from '../../../../utils/views/pages/Dynamics'
import secureLocalStorage from "react-secure-storage";

const ManagementInformation = (props) => {
    const student = props.student
    const formDisabled = props.formDisabled
    const setStudent = props.setStudent
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")
    const [showInstitutions, setShowInstitutions] = useState(false)
    const [selectOptions, setSelectOptions] = useState([])
    const validations = props.validations
    const user = JSON.parse(secureLocalStorage.getItem("user"));

    useEffect(() => {
        const runAsync = async () => {
            let params = {
                filter: { account: user.account }
            }

            const response = await getInstitutions(params);
            const { data } = response;

            if (data.success && data.institutions.length > 0) {
                setSelectOptions(data.institutions)
                setShowInstitutions(true)
            }
        }

        runAsync();

    }, [showInstitutions])

    let validateField = (e) => {        
        if (!e.target.value.trim() && e.target.required) {

            setWarning('The field \'' + titleCase(e.target.name) + '\' is required!')
            setShowModal(true)

        } else {
            if (validations[e.target.name] && !validations[e.target.name].test(e.target.value)) {
                setWarning('Invalid ' + titleCase(e.target.name))
                setShowModal(true)
            }
        }

    }

    let handleInput = (e) => {

        student[e.target.name] = e.target.value
        setStudent(student)

    }

    return (
        <>
            {/* Address */}
            <h6 className="heading-small text-muted mb-4">
                Management information
            </h6>
            <div className="pl-lg-4">
                <Row>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-institution"
                            >
                                Institution
                            </label>

                            {!showInstitutions ?
                                <div className="text-center p-1">
                                    <Spinner size="lg" />
                                </div>
                                :
                                <SelectInstitution
                                    institution={student?.institution}
                                    formDisabled={formDisabled}
                                    setStudent={setStudent}
                                    selectOptions={selectOptions}
                                    student={student} />
                            }

                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="12">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-detail"
                            >
                                Details
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={student?.detail}
                                id="input-detail"
                                name="detail"
                                placeholder="Student Details"
                                type="textarea"
                                rows="5"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={false}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                </Row>


            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />

        </>
    )
}

export default ManagementInformation;